import styled, { keyframes } from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import { productListingCardsStyles } from '../../styles/productListingCards';

export const ChatSectionStyled = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
  min-height: 0;
`;

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const ChatColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  min-height: 0;
  min-width: 0;
  overflow: hidden;

  &.poly-chat-layout {
    height: 100%;
  }

  .poly-chat-messages {
    flex: 1;
    min-height: 0;
    min-width: 0;
    height: auto !important;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 24px;
  }

  .poly-chat-empty {
    height: 100%;
    min-height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .poly-chat-thread {
    max-width: 48rem;
    margin: 0 auto;
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .poly-chat-input {
    flex-shrink: 0;
    padding: 16px 24px;
    border-top: 1px solid var(--card-border, #e5e5e5);
    background: var(--main-bg, #ffffff);

    .poly-chat-search {
      max-width: 48rem;
      margin: 0 auto;
    }
  }

  .poly-chat-print-header {
    display: none;
  }

  .error-text {
    color: var(--danger);
  }

  .chat-loader-text {
    display: block;
    font-weight: 400;
    margin-bottom: 10px;
    animation: ${pulse} 1.5s ease-in-out infinite;
  }

  .text-block {
    flex-grow: 1;
    height: 100vh;
    overflow: auto;
    padding: 15px 5px 15px 0;

    .user-text {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
      position: relative;
      padding-right: 0;
      padding-top: 4px;
      margin-bottom: 24px;

      .icon-box {
        display: none;
      }

      .title {
        max-width: 80%;
        margin: 0;
        padding: 12px 16px;
        border-radius: 16px 16px 4px 16px;
        background: var(--primary);
        color: #000;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.5;
        white-space: pre-line;
      }

      .see-source-button {
        position: static;
        flex-shrink: 0;
        margin: 0;
        padding: 5px 10px;
        color: var(--text-color-50);
        background: #f7f6f2;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        font-size: 12px;
        line-height: 1.2;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          color: var(--text-color);
          border-color: #d4d4d4;
          background: #f0eee8;
        }
      }
    }

    .heading {
      margin: 0 0 24px;
      position: relative;
      padding-left: 0;
      line-height: 28px;
      max-width: 100%;
      min-width: 0;
      overflow-x: hidden;

      &:not(.user-text) {
        .icon-box {
          display: none;
        }

        .ai-message-content,
        .streaming-text {
          max-width: 100%;
          width: 100%;
          min-width: 0;
          box-sizing: border-box;
          padding: 12px 16px;
          border-radius: 16px 16px 16px 4px;
          background: #f7f6f2;
          border: 1px solid #e5e5e5;
          color: var(--text-color);
          font-size: 14px;
          line-height: 1.5;
          overflow-x: hidden;
          overflow-wrap: anywhere;
          word-break: break-word;

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            color: var(--text-color);
          }

          p,
          li,
          span {
            color: var(--text-color);
          }

          strong,
          b {
            color: var(--text-color);
          }

          em {
            color: #5a5a5a;
          }

          th {
            color: var(--text-color);
          }

          td {
            color: #5a5a5a;
          }

          blockquote {
            color: #6b6b6b;
            border-left: 3px solid var(--primary);
            background: rgba(254, 221, 88, 0.12);
          }

          code {
            color: #5a4a00;
            background: rgba(254, 221, 88, 0.2);
            border: 1px solid #e5e5e5;
            border-radius: 4px;
            padding: 0.1em 0.35em;
          }

          pre code {
            color: #313131;
            background: transparent;
            border: none;
            padding: 0;
          }

          hr {
            border-color: #e5e5e5;
          }

          .product-listing-cards {
            max-width: none;

            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            .price {
              color: #1a1a1a !important;
            }

            p,
            li,
            span,
            .description,
            .feature-tags {
              color: #5a5a5a !important;
            }

            .price {
              color: #1a1a1a !important;
            }

            .feature-tags {
              color: #6b6b6b !important;
            }

            .view-detail-cta {
              color: #000 !important;
            }
          }
        }

        .ai-message-content:has(.product-listing-cards) {
          max-width: 100%;
        }
      }

      &:has(.product-listing-cards) {
        padding-left: 0;

        .icon-box {
          position: relative;
          top: 0;
          margin-bottom: 14px;
        }
      }

      .ai-message-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        overflow-x: hidden;
      }

      .streaming-text {
        white-space: pre-wrap;
        word-break: break-word;
        line-height: 1.6;
        color: var(--text-color);
      }

      ${productListingCardsStyles}

      a {
        text-decoration: underline;
        color: var(--primary-50);
      }

      .icon-box {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        font-size: 20px;
        line-height: 23px;
        font-weight: 700;
        text-transform: uppercase;
        border-radius: 50px;
        color: var(--text-color);
        background: var(--white);
        &--purple {
          background: rgb(135 137 147 / 48%);
          overflow: hidden;
        }
      }

      /* Scroll container keeps wide tables inside the message bubble */
      .chat-table-wrap {
        display: block;
        width: 100%;
        max-width: 100%;
        margin: 12px 0;
        overflow-x: auto;
        overflow-y: hidden;
        overscroll-behavior-x: contain;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          background: #f7f6f2;
        }
        &::-webkit-scrollbar-thumb {
          background: #d4d4d4;
          border-radius: 4px;
        }
      }

      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
      }

      .chat-table-wrap > table {
        width: 100%;
        min-width: 100%;
        table-layout: fixed;
      }

      th,
      td {
        border: 1px solid rgba(157, 157, 157, 0.3);
        border-spacing: 0;
        padding: 10px 12px;
        text-align: left;
        vertical-align: top;
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
        hyphens: auto;
        min-width: 0;
      }

      th {
        font-weight: 600;
        background: #efece4;
        color: var(--text-color);
      }

      .lucide-download {
        display: none;
      }

      .title {
        display: block;
        margin: 0;
      }

      pre {
        max-width: 100%;
        overflow-x: auto;
        background-color: #efece4;
        color: var(--text-color);
        padding: 16px;
        border-radius: 8px;
        font-family: 'Fira Code', 'Source Code Pro', monospace;
        font-size: 14px;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 10px;
        border: 1px solid #e5e5e5;

        &::-webkit-scrollbar {
          height: 5px;
        }
        &::-webkit-scrollbar-thumb {
          background: #d4d4d4;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #bdbdbd;
        }
      }
    }

    .title {
      display: block;
      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
      margin: 0 0 20px;
    }

    .text-box {
      width: 100%;
      margin: 0 0 20px;
    }

    .detail-box {
      width: 100%;
      padding: 20px 0;
      border-top: 1px solid #cdcdcd;

      .list {
        margin: 0;
        padding: 0 0 0 15px;

        li {
          margin: 0 0 15px;
        }
      }
    }

    .reponse-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .agent-name {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: var(--text-color);
        padding: 8px 15px;
        border-radius: 10px;
        background: #f7f6f2;
        border: 1px solid #e5e5e5;
      }

      .action-list {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;

        li {
          margin: 0;
        }

        button {
          font-size: 22px;
          line-height: 1;
          color: var(--light-gray);

          &:hover {
            color: var(--text-color);
          }
        }
      }
    }
  }

  .swiper-holder {
    position: relative;
    width: 100%;
    max-width: 100%;
    margin-bottom: 8px;

    .swiper {
      padding-top: 8px;
      margin-bottom: 12px;
      overflow: hidden;

      .swiper-slide {
        height: auto;
        box-sizing: border-box;

        .img-wrap {
          display: block;
          width: 100%;
          height: 140px;
          overflow: hidden;
          border-radius: 10px;
          border: 1px solid #e5e5e5;
          background: #f7f6f2;

          @media (min-width: 768px) {
            height: 180px;
          }

          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .swiper-controls {
      display: flex;
      gap: 10px;
      pointer-events: none;
    }

    .swiper-controls button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 8px;
      left: auto;
      z-index: 2;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      color: var(--text-color);
      border-radius: 50%;
      border: 1px solid #e5e5e5;
      cursor: pointer;
      pointer-events: auto;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

      &:hover {
        background: var(--primary);
        color: #000;
        border-color: var(--primary);
      }

      &::after {
        display: none;
      }

      svg {
        width: 18px;
        height: 18px;
      }
    }

    .swiper-button-prev {
      right: auto !important;
      left: 8px !important;
    }
  }

  /* Paper output is a light document, not a capture of the dark chat shell. */
  @media print {
    &.poly-chat-layout {
      display: block;
      width: 100%;
      height: auto;
      min-height: 0;
      overflow: visible;
      padding: 14mm 12mm;
      background: #fff;
      color: #111;
      font-size: 10.5pt;
    }

    .poly-chat-screen-header,
    .poly-chat-input,
    .see-source-button,
    .swiper-controls,
    .icon-box,
    .chat-steps-panel.is-collapsed {
      display: none !important;
    }

    * {
      animation: none !important;
      transition: none !important;
    }

    .poly-chat-print-header {
      display: block;
      width: 100%;
      max-width: none;
      margin: 0 0 20px;
      padding: 0 0 12px;
      border-bottom: 1px solid #d0d5dd;

      h1 {
        margin: 0 0 8px;
        color: #111;
        font-size: 19pt;
        line-height: 1.25;
      }

      .poly-chat-print-meta {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 2px 12px;
        margin: 0;

        dt {
          margin: 0;
          color: #667085;
          font-size: 8pt;
          font-weight: 700;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }

        dd {
          margin: 0;
          color: #344054;
          font-size: 9pt;
          overflow-wrap: anywhere;
        }
      }
    }

    .poly-chat-messages,
    .text-block {
      display: block;
      width: 100%;
      height: auto !important;
      min-height: 0;
      overflow: visible !important;
      padding: 0;
    }

    .poly-chat-thread {
      width: 100%;
      max-width: none;
      margin: 0;
      overflow: visible;
      orphans: 3;
      widows: 3;
    }

    .poly-chat-thread > div {
      break-inside: auto;
      page-break-inside: auto;
      margin: 0 0 18px;
    }

    .text-block .user-text {
      align-items: flex-end;
      gap: 4px;
      margin: 0 0 14px;
      padding: 0;
    }

    .text-block .user-text::before,
    .text-block .heading:not(.user-text)::before {
      content: 'You';
      display: block;
      margin: 0 0 4px;
      color: #667085;
      font-size: 8pt;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .text-block .heading:not(.user-text)::before {
      content: 'Assistant';
      margin-bottom: 6px;
    }

    .text-block .user-text .title {
      max-width: 85%;
      padding: 8px 12px;
      border: 1px solid #d8dde5;
      border-radius: 8px;
      background: #eef1f5 !important;
      color: #111 !important;
      font-size: 10.5pt;
      font-weight: 600;
      break-inside: avoid;
      page-break-inside: avoid;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .text-block .heading:not(.user-text) {
      margin: 0 0 20px;
      padding: 0;
      overflow: visible;
    }

    .text-block .heading:not(.user-text) .ai-message-content,
    .text-block .heading:not(.user-text) .streaming-text {
      width: 100%;
      max-width: 100%;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #1f1f1f !important;
      font-size: 10.5pt;
      line-height: 1.55;
      overflow: visible;
    }

    .text-block .heading a {
      color: #0b57d0 !important;
      text-decoration: underline;
    }

    .ai-message-content {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: #111 !important;
        break-after: avoid;
        page-break-after: avoid;
      }

      h1 {
        font-size: 15pt;
        margin: 14px 0 8px;
      }

      h2 {
        font-size: 13pt;
        margin: 14px 0 8px;
      }

      h3 {
        font-size: 12pt;
        margin: 12px 0 6px;
      }

      h4,
      h5,
      h6 {
        font-size: 11pt;
        margin: 10px 0 6px;
      }

      p,
      li,
      span {
        color: #1f1f1f !important;
      }

      p {
        margin: 0 0 8px;
      }

      strong,
      b {
        color: #000 !important;
      }

      em {
        color: #1f1f1f !important;
      }

      blockquote {
        margin: 10px 0;
        padding-left: 12px;
        border-left: 3px solid #d0d5dd;
        color: #475467 !important;
      }

      hr {
        border-color: #d0d5dd;
      }

      /* Markdown lists lose their markers to the global ul reset; restore them on paper only.
         Class-bearing lists come from embedded product HTML and keep their own styling. */
      ul:not([class]) {
        list-style: disc;
        margin: 8px 0;
        padding-left: 22px;
      }

      ol:not([class]) {
        list-style: decimal;
        margin: 8px 0;
        padding-left: 22px;
      }

      ul:not([class]) ul:not([class]) {
        list-style: circle;
        margin: 4px 0;
      }

      li {
        margin: 0 0 4px;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      code {
        padding: 1px 4px;
        border-radius: 4px;
        background: #f2f4f7;
        color: #0b3d91 !important;
        font-size: 9.5pt;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      pre code {
        padding: 0;
        background: transparent;
        color: #111 !important;
      }
    }

    .text-block .heading pre {
      max-width: 100%;
      margin: 10px 0;
      padding: 10px 12px;
      border: 1px solid #d8dde5;
      border-radius: 6px;
      background: #f6f8fa !important;
      color: #111 !important;
      font-size: 9.5pt;
      line-height: 1.45;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
      word-break: break-word;
      break-inside: auto;
      page-break-inside: auto;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .chat-table-wrap {
      margin: 10px 0;
      border: 1px solid #d0d5dd;
      border-radius: 6px;
      overflow: visible !important;
      break-inside: auto;
      page-break-inside: auto;
    }

    table,
    .chat-table-wrap > table {
      width: 100%;
      min-width: 0;
      table-layout: fixed;
      font-size: 9.5pt;
    }

    thead {
      display: table-header-group;
    }

    th,
    td {
      padding: 6px 8px;
      border: 1px solid #d0d5dd;
      color: #1f1f1f !important;
      break-inside: avoid;
      page-break-inside: avoid;
    }

    th {
      background: #f2f4f7 !important;
      color: #111 !important;
      font-weight: 700;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    tr {
      break-inside: avoid;
      page-break-inside: avoid;
    }

    /* Product cards stay real cards: photo as image, everything else as text. */
    .product-listing-cards {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 12px;
      margin: 12px 0;
    }

    .product-card {
      border: 1px solid #e4e7ec !important;
      border-radius: 10px;
      background: #fffaf3 !important;
      box-shadow: none !important;
      transform: none !important;
      overflow: hidden;
      break-inside: avoid;
      page-break-inside: avoid;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .product-card img.product-cover-image,
    .product-cover-image {
      height: 150px !important;
      max-height: 150px !important;
      object-fit: cover;
    }

    .product-info {
      padding: 12px 14px 14px !important;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 0 0 6px;
        font-size: 11pt !important;
      }

      p,
      .description {
        display: block !important;
        margin: 0 0 8px;
        overflow: visible !important;
        font-size: 9pt !important;
        -webkit-line-clamp: unset !important;
      }

      .price {
        margin: 0 0 6px;
        font-size: 10pt !important;
      }

      .feature-tags {
        margin: 0 0 10px;
        font-size: 8.5pt !important;
      }

      .view-detail-cta {
        padding: 8px 12px;
        border-radius: 6px;
        background: #1a1a1a !important;
        color: #fff !important;
        font-size: 9pt;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }

    /* Steps mirror the screen: collapsed panels are dropped, open ones print in full. */
    .chat-steps-panel {
      margin: 0 0 14px;
      border: 1px solid #d8dde5 !important;
      border-radius: 8px;
      background: #fff !important;
      overflow: visible !important;
      break-inside: auto;
      page-break-inside: auto;
    }

    .chat-steps-panel,
    .chat-steps-panel * {
      color: #1f1f1f !important;
      background-color: transparent !important;
      opacity: 1 !important;
      transform: none !important;
    }

    .chat-steps-content {
      height: auto !important;
      overflow: visible !important;
    }

    .chat-steps-panel pre {
      max-height: none !important;
      margin: 0;
      overflow: visible !important;
      color: #344054 !important;
      font-size: 8.5pt;
    }

    .swiper-holder {
      break-inside: auto;
      page-break-inside: auto;

      .swiper {
        overflow: visible;
      }

      .swiper-wrapper {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 10px;
        transform: none !important;
      }

      .swiper-slide {
        width: auto !important;
        margin: 0 !important;
        break-inside: avoid;
        page-break-inside: avoid;

        .img-wrap {
          height: 120px;
          border: 1px solid #d8dde5;
          background: #fff;
        }
      }
    }
  }
`;

export const SearchResultCol = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  flex-shrink: 0;
  width: 300px;
  padding: 10px 20px;
  border-left: 1px solid #e5e5e5;
  background: #ffffff;
  z-index: 999;
  color: var(--text-color);

  @media (min-width: 1200px) {
    width: 500px;
  }
  .content-box {
    box-shadow: none;
    padding: 8px 16px;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: 0.3s all ease-in-out;
    border: 1px solid #e5e5e5;
    background: #f7f6f2;
    &:hover {
      border: 1px solid var(--primary);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
  }

  .tablist {
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
    display: flex;
    gap: 15px;
    position: relative;
    padding-right: 35px;

    @media (min-width: 1400px) {
      gap: 30px;
    }
    .source-close {
      width: 20px;
      height: 20px;
      border: 1px solid var(--danger);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      position: absolute;
      right: 5px;
      top: 5px;
    }
    li {
      margin: 0;

      button {
        display: block;
        font-size: 16px;
        line-height: 20px;
        text-transform: capitalize;
        padding: 0 0 5px;
        color: var(--text-color-50);
        border-bottom: 2px solid transparent;

        @media (min-width: 1400px) {
          font-size: 18px;
          line-height: 22px;
        }

        &.active {
          font-weight: 700;
          color: var(--text-color);
          border-bottom: 2px solid var(--primary);
        }
      }
    }
  }

  .tab-content {
    position: relative;

    .imgs-wrap,
    .video-wrap {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
    }
  }

  .content-box {
    position: relative;
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;

    .head {
      margin: 0 0 10px;
      display: flex;
      align-items: center;
      gap: 10px;

      .img-box {
        width: 22px;
        flex-shrink: 0;
      }

      .text {
        font-size: 14px;
        line-height: 18px;
        display: block;
        color: var(--text-color-50);
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .text-box {
      width: 100%;
    }
    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      margin: 0 0 10px;
    }

    .detail-holder {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 400px;
      padding: 15px;
      border-left: 1px solid #cdcdcd;
      border-radius: 10px 0 0 10px;
      background: var(--white);
      transform: translateX(102%);
      transition: all 0.3s ease-in-out;
      z-index: 72;

      .detail-active & {
        transform: translateX(0);
      }

      @media screen and (min-width: 1600px) {
        width: 500px;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 0 15px;

        .title {
          font-size: 18px;
          line-height: 22px;
          font-weight: 700;
          margin: 0;
        }

        .btn-close {
          width: 25px;
          height: 25px;
          border: 1px solid var(--text-color);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }
      }

      .text-area {
        width: 100%;
        height: calc(100vh - 70px);
        overflow: auto;
        padding-right: 5px;
      }
    }
  }
  .block-heading {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--text-color-50);
  }

  .imgs-holder {
    max-width: 100%;
    overflow-x: auto;
    .img-wrap {
      width: 100%;
      height: 200px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-bottom: 20px;
      }
    }
  }
`;

export const ReponseMenu = styled(Menu)`
  ul {
    width: 300px;
    padding: 10px;
    border-radius: 20px;
    border: 3px solid rgba(157, 157, 157, 0.4);
    box-shadow: 0 0 10px rgba(157, 157, 157, 0.6);
  }
`;
export const MenuBtn = styled(MenuButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 50px;
  padding: 10px 6px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  text-transform: capitalize;
  border-radius: 12px;
  border: 1px solid rgba(157, 157, 157, 0.6);
  background: #f1f1f1;

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 12px;
    background: rgba(26, 42, 108, 0.1);
  }
`;
export const StyleItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  margin: 0 0 6px;
  border-radius: 10px;
  border: 1px solid transparent;

  &.active,
  &:hover {
    border-color: var(--text-color);
    background: rgba(254, 221, 88, 0.1);
  }

  &:last-child {
    margin: 0;
  }

  .wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .icon-box {
    width: 35px;
  }

  .pro {
    display: block;
    min-width: 50px;
    padding: 5px;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--text-color);
    text-align: center;
    border-radius: 10px;
    background: var(--primary);
  }
`;
